import React from 'react';

const ResumeSection = ({ section }) => {
    return (
        <div className='section'>
            <h3>{section.title}</h3>
            {section.sections.map(sec => {
                return (
                    <div key={sec.title} className='sub'>
                        <div className='top-line'>
                        <h4>{sec.title}{sec.location && <span className='resume-location'>, {`${sec.location}`}</span>}</h4>
                            {sec.dateOrLink.includes('http') ?
                            <a rel='noopener noreferrer' target='_blank' href={sec.dateOrLink}>Github</a> :
                            <p className='dates'>{sec.dateOrLink}</p>}
                        </div>
                        {sec.secondaryTitle && <p className='sec-title'>{sec.secondaryTitle}</p>}
                        {sec.description && <p className='description'>{sec.description}</p>}
                        <ul className='bullets'>
                            {sec.bullets.map(bullet => {
                                return <li key={bullet}>{bullet}</li>
                            })}
                        </ul>
                    </div>
                )
            })}
        </div>
    )
}

export default ResumeSection;